import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { Separator } from '@connected/ui/components/separator';
import { useQuery } from '@tanstack/react-query';
import { Fragment, useMemo } from 'react';

import type { TechnicalDrawing } from '../utils/drawing-types';

import { DrawingItem } from './drawing-item';

export type DrawingListProps = {
    electricalProjectVersionId: string;
};

export function DrawingList({ electricalProjectVersionId }: DrawingListProps) {
    const query = useQuery(
        elektraAppQueryOptions.project.request.technicalDrawingsQueryOptions({
            electricalProjectVersionId,
        }),
    );

    const technicalDrawings = useMemo<TechnicalDrawing[]>(
        () => query.data?.TechnicalDrawings.map(drawing => ({
            ElectricalProjectTechnicalDrawingId: drawing.ElectricalProjectTechnicalDrawingId,
            ElectricalProjectFileId: drawing.ElectricalProjectFileId ?? null,
            Name: drawing.Name ?? null,
            Description: drawing.Description ?? null,
            Location: drawing.Location ?? null,
            IsDrawingPresent: drawing.IsDrawingPresent ?? null,
        })) ?? [],
        [query.data],
    );

    return (
        <div className="flex flex-col gap-4">
            {technicalDrawings.map((drawing, index) => (
                <Fragment key={drawing.ElectricalProjectTechnicalDrawingId}>
                    {index > 0 && <Separator orientation="horizontal" />}
                    <DrawingItem
                        technicalDrawing={drawing}
                        electricalProjectVersionId={electricalProjectVersionId}
                    />
                </Fragment>
            ))}
            {technicalDrawings.length === 0 && (
                <p className="text-center text-text-secondary">
                    Geen technische tekeningen gevonden. Voeg een nieuwe tekening toe door op "Toevoegen" te klikken.
                </p>
            )}
        </div>
    );
}
